import { Component, NgZone, OnInit } from "@angular/core";

import { ElementRef, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  DetailedOrderStatusRequestPromiseService,
  TradeDealPromiseService,
} from "shared/cubiq-services";
import { GoldenLayoutComponent } from "../golden-layout/golden-layout-component";
import { GoldenLayoutPopout } from "../golden-layout/golden-layout-popout";

import svgPanZoom from "svg-pan-zoom";
import { d3 } from "../shared/d3/d3";

import { BfxSysConfigUtilService } from "shared/auth-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
import { DealtPricingService } from "shared/cubiq-services/lookup/pricing/impl/DealtPricingService";
const logger = LoggerService.for(__dirname);

/* TODO -
1. drop golden-layout entanglemets, 
2. integrate with order details + others
3. move to sass in relevent locations 
 */

@Component({
  selector: `bfx-strategy-viewer`,
  templateUrl: "./html/bfx-strategy-viewer.html",
  styles: [],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BfxStrategyViewerComponent implements OnInit, GoldenLayoutComponent {
  @ViewChild("strategyLayoutTarget", { static: true })
  private strategyLayoutTarget: ElementRef;

  public selectedIds: any;

  public tradeDealSelectedIds: any;

  public parentPopup: GoldenLayoutPopout;

  public embeddedTradeCount: number | null = null;

  public currentLadderBlotter: any;

  /**
   * see this.parentPopup.embeddedComponentConfig.data
   */
  public persistEmbeddedComponentConfigData: boolean = true;

  constructor(
    private _detailedOrderService: DetailedOrderStatusRequestPromiseService,
    private _tradeDealService: TradeDealPromiseService,
    private ngZone: NgZone,
    private sysConfigUtilService: BfxSysConfigUtilService,
    private pricingService: DealtPricingService,
  ) {}

  public control: any = {
    mode: true,
    orderData: null,
    containerHeight: 324,
    scrollbarConfig: {
      suppressScrollX: true,
    },
    strategyLayout: null,
    panzoom: null,
  };

  public config: any = {
    debug: false,
  };

  ngOnInit(): void {
    //
  }

  // Golden layout popout component creation callback
  glInit(data: any, container: any, _state: any): void {
    this.currentLadderBlotter =
      container != null
        ? container._config != null
          ? container._config.ladderBlotter != null
            ? container._config.ladderBlotter
            : null
          : null
        : null;

    if (data.tradeDealSelectedIds) {
      this.tradeDealSelectedIds = data.tradeDealSelectedIds;

      this._tradeDealService.getTradeDeals(data.tradeDealSelectedIds).then((tradeDeals) => {
        let selectedIds = tradeDeals.map((tradeDeal) => {
          return tradeDeal.orderId;
        });

        this.selectedIds = selectedIds;

        this.initMediatedOrderDetails();
      });
    } else {
      this.selectedIds = data.selectedIds;

      this.initMediatedOrderDetails();
    }
  }

  initMediatedOrderDetails() {
    this._detailedOrderService
      .request(this.selectedIds[0])
      .then((orderData: CubiqTS.OrderDataImpl) => {
        this.control.orderData = orderData;

        let mockOrderData = this.mockOrderDataA(orderData);
        this.parentPopup.title = `Order: ${orderData.orderId.toString()} Strategy Diagram `;
        this.control.orderDetails = true;

        let target = this.strategyLayoutTarget.nativeElement;
        let panzoom = null;
        let strategyLayout = null;

        this.control.strategyLayout = strategyLayout = d3.layout
          .strategy(this.pricingService, this.sysConfigUtilService)
          .config({
            width: target.offsetWidth,
            height: target.offsetHeight,
          })
          .render(mockOrderData, target);
        this.renderPanZoom();

        setTimeout(() => {
          if (panzoom) {
            panzoom.destroy();
          }
          let mockOrderData = this.mockOrderDataAnB(orderData);
          strategyLayout.render(mockOrderData, target, orderData.orderId.toString());

          this.renderPanZoom();
        }, 5000);
      });
  }

  mockOrderDataA(orderData) {
    orderData = Object.assign(new CubiqTS.OrderDataImpl(), orderData);

    let orderDataMockA = Object.assign(new CubiqTS.OrderDataImpl(), orderData);
    orderDataMockA.orderId = new CubiqTS.Long(123456);
    orderDataMockA.requestRt = orderDataMockA.requestRt.plus("0.0001");
    orderDataMockA.clientIntent =
      orderDataMockA.clientIntent == CubiqTS.OrderIntent.BUY
        ? CubiqTS.OrderIntent.SELL
        : CubiqTS.OrderIntent.BUY;

    let mockRelationshipA = new CubiqTS.Relationship();
    mockRelationshipA.relationshipType = CubiqTS.OrderRelationshipType.OCO;
    mockRelationshipA.order = orderDataMockA;
    mockRelationshipA.orderId = orderDataMockA.orderId.toString();
    orderData.siblingRelationship = mockRelationshipA;

    return orderData;
  }

  mockOrderDataAnB(orderData) {
    orderData = Object.assign(new CubiqTS.OrderDataImpl(), orderData);

    let orderDataMockA = Object.assign(new CubiqTS.OrderDataImpl(), orderData);
    orderDataMockA.orderId = new CubiqTS.Long(123456);
    orderDataMockA.requestRt = orderDataMockA.requestRt.plus("0.0001");
    orderDataMockA.clientIntent =
      orderDataMockA.clientIntent == CubiqTS.OrderIntent.BUY
        ? CubiqTS.OrderIntent.SELL
        : CubiqTS.OrderIntent.BUY;

    let mockRelationshipA = new CubiqTS.Relationship();
    mockRelationshipA.relationshipType = CubiqTS.OrderRelationshipType.OCO;
    mockRelationshipA.order = orderDataMockA;
    mockRelationshipA.orderId = orderDataMockA.orderId.toString();

    let orderDataMockB = Object.assign(new CubiqTS.OrderDataImpl(), orderData);
    orderDataMockB.orderId = new CubiqTS.Long(123457);
    orderDataMockB.requestRt = orderDataMockB.requestRt.plus("0.005");
    orderDataMockB.clientIntent =
      orderDataMockB.clientIntent == CubiqTS.OrderIntent.BUY
        ? CubiqTS.OrderIntent.SELL
        : CubiqTS.OrderIntent.BUY;

    let mockRelationshipB = new CubiqTS.Relationship();
    mockRelationshipB.relationshipType = CubiqTS.OrderRelationshipType.IFDONE;
    mockRelationshipB.order = orderDataMockB;
    mockRelationshipB.orderId = orderDataMockB.orderId.toString();

    orderData.siblingRelationship = mockRelationshipA;
    orderData.childRelationships = [mockRelationshipB];

    return orderData;
  }

  renderPanZoom() {
    if (this.control.strategyLayout === null) {
      return;
    }

    setTimeout(() => {
      this.ngZone.runOutsideAngular(() => {
        // 2. svgPanZoom is non-angular
        this.control.panzoom = svgPanZoom(this.control.strategyLayout.node(), {
          controlIconsEnabled: true,
          zoomEnabled: true,
          dblClickZoomEnabled: false,
          mouseWheelZoomEnabled: true,
          preventMouseEventsDefault: true,
          zoomScaleSensitivity: 0.2,
          minZoom: 0.75,
          maxZoom: 1.5,
          fit: true,
          contain: false,
          center: false,
          beforePan: function (oldPan, newPan) {
            let gutterWidth = 100,
              gutterHeight = 100,
              // Computed variables
              sizes = this.getSizes(),
              leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
              rightLimit = sizes.width - gutterWidth - sizes.viewBox.x * sizes.realZoom,
              topLimit =
                -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
              bottomLimit = sizes.height - gutterHeight - sizes.viewBox.y * sizes.realZoom;
            let customPan: any = {};
            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x));
            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y));
            return customPan;
          },
        });
      });
    }, 4);
  }

  setParentPopup(parentPopup: GoldenLayoutPopout) {
    this.parentPopup = parentPopup;
    this.parentPopup.setShowDock(false);
    this.parentPopup.setShowRefresh(false);
  }

  close(_$event: MouseEvent) {
    this.parentPopup.close();
  }

  onClose(): boolean {
    return true;
  }

  select($event) {
    logger.out.info("selection: " + ($event.detail as any).id);
  }

  remove($event: CustomEvent) {
    logger.out.info("remove: " + ($event.detail as any).id);
  }
}
